import React from 'react';
import { NavItem, NavLink, Nav, Container, Row, Col } from 'reactstrap';

import { Facebook, Twitter, Instagram, LinkedIn } from '@material-ui/icons';

import appStoreBadge from '../../assets/AppleAppStoreBadge.svg';
import googlePlayBadge from '../../assets/googlePlayBadge.svg';

function FooterComponent() {
    return (
        <Container>
            <Row style={{ height: '65px' }} className="align-items-center">
                <a
                    style={{ padding: '0 3px' }}
                    href="https://apps.apple.com/us/app/onward-delivery/id1587073563"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img src={appStoreBadge}></img>
                </a>
                <a
                    style={{ padding: '0 3px', height: '40px' }}
                    href="https://play.google.com/store/apps/details?id=com.onwardship.onwardship"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img style={{ height: '40px' }} src={googlePlayBadge}></img>
                </a>
            </Row>
            <Row style={{ height: '65px' }} className="align-items-center justify-content-lg-between">
                <Col lg="6" xs="9">
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div
                            className="copyright"
                            style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap' }}
                        >
                            © {new Date().getFullYear()} Onward Delivery
                            <div
                                style={{
                                    marginLeft: '15px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexWrap: 'nowrap',
                                }}
                            >
                                <a
                                    style={{ padding: '0 3px' }}
                                    href="https://twitter.com/onward_delivery"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <Twitter style={{ color: '#4c4c4c' }} />
                                </a>
                                <a
                                    style={{ padding: '0 3px' }}
                                    href="https://www.instagram.com/onward_delivery/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <Instagram style={{ color: '#4c4c4c' }} />
                                </a>
                                <a
                                    style={{ padding: '0 3px' }}
                                    href="https://www.facebook.com/onwardd"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <Facebook style={{ color: '#4c4c4c' }} />
                                </a>
                                <a
                                    style={{ padding: '0 3px' }}
                                    href="https://www.linkedin.com/company/onward-delivery/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <LinkedIn style={{ color: '#4c4c4c' }} />
                                </a>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col lg="6" xs="3">
                    <Nav className="nav-footer justify-content-lg-end">
                        <NavItem className="footersmall">
                            <NavLink href="/cancellationpolicy" target="_blank">
                                Cancel Policy
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink href="/privacy" target="_blank">
                                Privacy
                            </NavLink>
                        </NavItem>
                        <NavItem className="footersmall">
                            <NavLink
                                href="https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE"
                                target="_blank"
                            >
                                MIT License
                            </NavLink>
                        </NavItem>
                    </Nav>
                </Col>
            </Row>
        </Container>
    );
}

export default FooterComponent;
